<!-- 实验室废水处置方案 -->
<template>
  <div class="basicIntro wow animate__animated animate__fadeIn">
    <div class="mainBox introText">
      <div>智慧实验室</div>
      <div>
        基于数字孪生技术，对现实实验室进行高精度3D建模，构建与实体高度一致的虚拟模型<br />
        集成物联网、大数据、AI等技术，实时采集设备运行参数与环境数据<br />
        具备可视化展示与交互功能，支持多角度观察实验室状态及模拟操作<br />
        结合智能预警与决策支持系统，及时发现隐患、提供解决方案，提升管理效率并增强安全保障<br />
      </div>
    </div>
  </div>
  <div class="wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center">
      <div class="text1">管理痛点</div>
    </div>
    <div class="brightPoint mainBox">
      <div class="brightPointInfo">
        <OssImg class="brightPointIcon" src="/UIV3/num1.png" alt="" />
        <div>流程管理协同效率低下</div>
        <div>
          实验室涉及设备、人员、危化品等多要素管理，各环节数据分散，部门间信息不通畅，导致资源调度混乱、决策滞后。
        </div>
      </div>

      <div class="brightPointInfo">
        <OssImg class="brightPointIcon" src="/UIV3/num2.png" alt="" />
        <div>安全管理存在盲区</div>
        <div>
          实验室设备、仓储、环境等系统数据分散，格式不统一，信息流通受阻。
        </div>
      </div>
      <div class="brightPointInfo">
        <OssImg class="brightPointIcon" src="/UIV3/num3.png" alt="" />
        <div>违规行为失控</div>
        <div>精密设备依赖人工巡检发现故障，维修响应慢，易影响实验进度；设备操作复杂，培训难度大。</div>
      </div>
      <div class="brightPointInfo">
        <OssImg class="brightPointIcon" src="/UIV3/num4.png" alt="" />
        <div>数据价值挖掘不足</div>
        <div>
          实验数据分散存储，缺乏系统性分析，历史数据追溯困难，难以支撑实验优化与科研创新。
        </div>
      </div>
    </div>
  </div>
  <div class="advBox wow animate__animated animate__fadeIn">
    <div class="advText">方案矩阵</div>
    <OssImg class="advImg" src="/UIV3/wise1.png" alt="" />
  </div>
  <section class="mainBox wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center">
      <div class="text1">方案优势</div>
    </div>
    <Advantage :list="TECHNICAL_CAPACITY"></Advantage>
  </section>
</template>

<script setup>
import { ref } from "vue";
import Card from "@/components/card.vue";
import Advantage from "./components/Advantage.vue";
const TECHNICAL_CAPACITY = ref([
  {
    title: "全场景可视化管理 ",
    desc: "构建实验室 1:1 数字孪生模型，将设备布局、实验流程、人员活动等要素直观呈现，实现空间、资源、操作状态的实时可视化，帮助管理者全局把控实验室运行，快速定位异常点",
    imgPath: "images/solution/digitalTwin/big_icon1.png",
    key: 0,
  },
  {
    title: "智能预测与主动运维",
    desc: "依托数字孪生与 AI 算法，对设备运行数据深度分析，提前 72 小时预测故障风险，主动推送维护计划，设备非计划性停机时间减少 60%，保障实验连续性",
    imgPath: "images/solution/digitalTwin/big_icon2.png",
    key: 1,
  },
  {
    title: "安全风险零死角防控",
    desc: "整合温湿度、气体浓度、危化品存量等传感器数据，通过数字孪生模型实时预警安全隐患；模拟火灾、泄漏等事故场景，生成最优疏散与应急方案，安全事故响应效率提升 80%",
    imgPath: "images/solution/digitalTwin/big_icon3.png",
    key: 2,
  },
  {
    title: "数据驱动科研创新",
    desc: "自动采集实验全流程数据，结合数字孪生可视化分析，挖掘实验变量关联规律，辅助科研人员优化实验设计；完整的历史数据追溯功能，为学术研究提供可靠支撑",
    imgPath: "images/solution/digitalTwin/big_icon4.png",
    key: 3,
  },
  {
    title: "灵活适配与扩展性",
    desc: "采用模块化架构设计，可根据实验室规模、学科特点灵活定制功能模块；支持硬件设备、软件系统的平滑升级，满足未来业务扩展需求",
    imgPath: "images/solution/digitalTwin/big_icon5.png",
    key: 4,
  },
  {
    title: "合规管理全程追溯",
    desc: "自动记录设备维护、危化品流转、实验操作等数据，生成完整电子档案，确保符合 ISO、CNAS 等认证规范，轻松应对监管审查，降低合规风险",
    imgPath: "images/solution/digitalTwin/big_icon6.png",
    key: 5,
  },
]);
</script>

<style lang="scss" scoped>
.basicIntro {
  width: 100vw;
  height: 22.375rem;
  padding: 1rem 0 2rem 0;
  background: #deedff url("@/assets/images/bg/wiseBg.png") no-repeat center;
  background-size: cover;
  display: flex;
  flex-direction: column;

  .introText {
    width: 100%;

    >div:first-child {
      font-weight: bold;
      font-size: 2.5rem;
      color: #212121;
      margin-bottom: 1.5rem;
    }

    >div:nth-child(2) {
      font-weight: 500;
      font-size: 1.25rem;
      color: #888888;
      line-height: 2rem;
    }
  }
}

.brightPoint {
  display: flex;
  justify-content: space-between;
  padding-top: 0.5rem;
  margin-bottom: 40px;

  .brightPointInfo {
    width: 18.75rem;
    margin-right: 1.5rem;

    .brightPointIcon {
      width: 100px;
      height: 65px;
    }

    >div:nth-of-type(2) {
      margin-top: -1rem;
      font-weight: bold;
      font-size: 1rem;
      color: #212121;
      margin-bottom: 0.5rem;
      display: flex;
      align-items: center;
    }

    >div:nth-of-type(3) {
      font-weight: 500;
      font-size: 0.875rem;
      color: #888888;
      line-height: 1.3125rem;
      text-indent: 2em;
    }
  }
}

.advBox {
  width: 100%;
  position: relative;
  margin-top: 3rem;

  .advImg {
    width: 100%;
  }

  .advText {
    position: absolute;
    top: 1rem;
    left: 50%;
    transform: translateX(-50%);
    font-weight: bold;
    font-size: 2.5rem;
    color: #212121;
    z-index: 99;
  }
}
</style>
